import Button from "olive-react-myoneui/lib/Button";
import Card from "olive-react-myoneui/lib/Card";

function NoItemsInfo({
  className = "",
  title,
  description,
  buttonText,
  buttonLink
}) {
  return (
    <Card className={`${className} empty-block-card`}>
      <Card.Body className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
        <div className="empty-block">
          {title && <h6><strong>{title}</strong></h6>}
          {description && <p>{description}</p>}
          {buttonLink && (
            <Button variant="secondary" onClick={(e) => {
              e.preventDefault();
              window.location.replace(buttonLink);
            }}>
              {buttonText}
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default NoItemsInfo;
